import { composeIO } from 'react-compose-io'
import { regularizacaoPerdasIO } from './RegularizacaoPerdas.IO'
import { RegularizacaoPerdasView } from './RegularizacaoPerdas.View'

export const RegularizacaoPerdas = composeIO(RegularizacaoPerdasView, regularizacaoPerdasIO)
